// components/ShareModal.tsx
import {
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaEnvelope,
  FaCopy,
} from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { IoShareSocialOutline } from "react-icons/io5";
import { useState } from "react";
import { motion } from "framer-motion";

export default function ShareModal({ onClose }: { onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  const shareLink = "https://www.fresha.com/a/willomina-woollahra-107-queen...";

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareApps = [
    { label: "WhatsApp", icon: FaWhatsapp, color: "text-green-500" },
    { label: "Facebook", icon: FaFacebook, color: "text-blue-600" },
    { label: "Twitter", icon: FaTwitter, color: "text-blue-400" },
    { label: "LinkedIn", icon: FaLinkedin, color: "text-blue-700" },
    { label: "Email", icon: FaEnvelope, color: "text-red-500" },
    {
      label: "Copy Link",
      icon: FaCopy,
      color: "text-gray-600",
      action: handleCopy,
    },
  ];

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl w-[90%] max-w-lg p-6 shadow-xl relative"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
        >
          <MdClose size={22} />
        </button>

        {/* Link Preview */}
        <div className="border border-gray-200 rounded-lg p-4 flex items-center gap-4 mb-6">
          <img
            src="https://globalmira.s3.ap-southeast-2.amazonaws.com/rolliciouscover2.jpg"
            alt="Preview"
            className="w-14 h-14 rounded object-cover"
          />
          <div className="flex-1">
            <h3 className="text-sm font-semibold">Willomina</h3>
            <p className="text-xs text-gray-500 truncate">{shareLink}</p>
          </div>
          <button
            onClick={handleCopy}
            className="text-blue-500 text-sm font-medium"
          >
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>

        {/* Share Using */}
        <h4 className="text-sm font-semibold mb-2 text-gray-600">
          Share using
        </h4>
        <div className="grid grid-cols-3 gap-4 text-center">
          {shareApps.map(({ label, icon: Icon, color, action }) => (
            <button
              key={label}
              onClick={action}
              className="flex flex-col items-center text-sm text-gray-600 hover:text-black"
            >
              <div
                className={`w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-1 text-xl ${color}`}
              >
                <Icon />
              </div>
              {label}
            </button>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
